import { QueryClient } from "@tanstack/react-query";

/** @deprecated use one from container */
export const queryClient = new QueryClient();
